<template>
  <div>
    <!-- Recebimento Operadores Table -->
    <recebimento-operadores-table
      ref="recebimentoOperadoresTableRef">
    </recebimento-operadores-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const recebimentoOperadoresTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (recebimentoOperadoresTableRef.value) {
    await recebimentoOperadoresTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('RecebimentoOperadoresPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('RecebimentoOperadoresPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
